
import RefundFDAService from '../../services/refund-fda-service'
import RepositoryService from '../../services/repository-service'
import {
  AuthModule
} from '@/store/modules/AuthModule'
import {
  ToastModule
} from '@/store/modules/ToastModule'
import {
  Component,
  Vue
} from 'vue-property-decorator'
import DateHelper from '@/mixins/date-mixins'
import Currencies from '@/data/currency.json'
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue'
import {
  Printd
} from 'printd'
import {
  Validations
} from 'vuelidate-property-decorators'
import {
  Vuelidate
} from 'vuelidate'
import {
  required
} from 'vuelidate/lib/validators'
import {
  NotifyModule
} from '@/store/modules/NotifyModule'
import TemplateFda from './Print/TemplateFDA.vue'
@Component({
  name: 'RefundFDA',
  components: {
    VueAutonumeric,
    TemplateFda
  }
})
export default class RefundFDA extends Vue {
    protected currencies = Currencies
    protected types = ['Invoice', 'Non-Invoice', 'FDA']
    protected attentionTypes = ['Agent', 'Staff', 'Other']
    protected paymentMethods: any = ['Bank', 'Cheque', 'Cash']
    protected paymentDetails: any = ['Received', 'Received USD Draft']
    protected clients: any = []
    protected contacts: any = []
    protected attentionType: any = null
    protected document: any = null
    protected showComponent = false
    protected isEditForm: any = false
    protected jobs: any = []
    protected lines: any = []
    protected styles = ['https://api.smc-spl-application.com/print.css']

    protected refund: any = {
      id: null,
      date: null,
      refund_number: null,
      type: null,
      payment_method: null,
      payment_detail: null,
      client: {},
      exchange_rate: null,
      amount: null,
      invoice_value: null,
      oil_recovery: null,
      total_settled: null,
      created_user: null,
      modified_user: null
    }

    protected fields = [{
      key: 'checked',
      label: '',
      thStyle: {
        width: '4%'
      },
      class: 'text-center'
    },
    {
      key: 'line_number',
      label: '#',
      thStyle: {
        width: '4%'
      },
      class: 'text-right'
    },
    {
      key: 'job_number',
      label: 'Job Number',
      thStyle: {
        width: '10%'
      },
      class: 'text-left'
    },
    {
      key: 'fda_number',
      label: 'Invoice Number',
      thStyle: {
        width: '15%'
      },
      class: 'text-left'
    },
    {
      key: 'vessel_name',
      label: 'Vessel',
      thStyle: {
        width: '20%'
      },
      class: 'text-left'
    },
    {
      key: 'date',
      label: 'Date',
      thStyle: {
        width: '8%'
      },
      class: 'text-left'
    },
    {
      key: 'amount',
      label: 'Amount',
      thStyle: {
        width: '10%'
      },
      class: 'text-right'
    },
    {
      key: 'total_quantity',
      label: 'Total Quantity',
      thStyle: {
        width: '10%'
      },
      class: 'text-right'
    },
    {
      key: 'oil_quantity',
      label: 'Oil Quantity',
      thStyle: {
        width: '10%'
      },
      class: 'text-right'
    }
    ]

      $v: Vuelidate

      @Validations()
      validations = {
        refund: {
          date: {
            required
          },
          type: {
            required
          },
          payment_method: {
            required
          },
          client: {
            required
          }
        }
      }

      /* @Watch('refund', {
        deep: true
      })
      setFDAs () {
        if (this.refund.type === 'FDA' && Object.keys(this.refund.client).length !== 0) {
          this.populateFDAs()
        }
      } */

      get total () {
        let tot = 0
        return this.lines.reduce((total, line) => {
          tot = (total + parseFloat(line.total))
          this.refund.transaction_amount = tot
          return tot
        }, 0)
      }

      get oilQuantity () {
        let tot = 0
        return this.lines.reduce((total, line) => {
          tot = (total + parseFloat(line.oil_quantity))
          this.refund.oil_quantity = tot
          return tot
        }, 0)
      }

      get totalQuantity () {
        let tot = 0
        return this.lines.reduce((total, line) => {
          tot = (total + parseFloat(line.total_quantity))
          this.refund.total_quantity = tot
          return tot
        }, 0)
      }

      public show (item: any, transaction: any) {
        this.showComponent = true

        if (Object.keys(transaction).length !== 0) {
          this.isEditForm = true
          this.populateRefundFDA(transaction.source_id)
        } else {
          this.isEditForm = false
          this.refund.date = DateHelper.today('dd/mm/yyyy')
          this.refund.client = {
            id: item.client_id,
            name: item.client_name
          }
        }
        this.document = new Printd()
        this.populateClients()
      }

      public hide () {
        this.cancel()
        this.showComponent = false
      }

      /* protected editLine (lineIndex: number) {
        this.lines[lineIndex].isEdit = !this.lines[lineIndex].isEdit
      } */

      /* protected deleteLine (data: any) {
        const msg = `Are you sure you want to delete line ${data.index + 1}?`
        if (confirm(msg) === true) {
          if (data.item.id !== null) {
            RefundService.deleteLine(this.refund.id, data.item.id).then((response) => {
              ToastModule.message(response.data.message)
              this.lines.splice(data.index, 1)
            }).catch(error => {
              ToastModule.message(error.response.data.message)
            })
          } else this.lines.splice(data.index, 1)
        }
      } */

      /* protected deleteLines () {
        const msg = 'Are you sure you want to delete all lines ?'
        if (confirm(msg) === true) {
          this.lines = []
          this.addLine()
        }
      } */

      protected populateRefundFDA (refundId) {
        RefundFDAService.getRefundFDA(refundId).then((response) => {
          this.refund = response.data
          this.refund.client = {
            id: response.data.client_id,
            name: response.data.client_name
          }
          this.lines = response.data.lines.map(line => ({
            ...line,
            accepted: true,
            job_id: response.data.job_id,
            job_number: response.data.job_number,
            vessel_name: response.data.vessel_name,
            date: response.data.operation_commenced_date,
            total: line.amount,
            fda_number: response.data.refund_number,
            total_quantity: (parseFloat(line.oil_quantity) + parseFloat(line.water_quantity)).toFixed(2)
          }))
        })
      }

      protected async populateClients () {
        const response = await RepositoryService.getClients()
        this.clients = response.data
      }

      protected async populateFDAs () {
        if (this.refund.type === null) {
          NotifyModule.set('Please select refund type to proceed')
          return false
        }

        this.lines = []
        if (this.refund.type === 'FDA' && this.refund.client.id !== undefined) {
          const response = await RefundFDAService.getFDAs(this.refund.client.id)
          this.lines = response.data.map(line => ({
            ...line,
            date: line.operation_commenced_date,
            oil_quantity: !line.oil_quantity ? 0 : line.oil_quantity,
            total_quantity: !line.total_quantity ? 0 : line.total_quantity,
            total: !line.total ? 0 : line.total
          }))
        }
      }

      protected save () {
        if (!this.isValidated()) return false
        const refunds: any = []

        this.lines.filter(line => line.accepted).forEach((line) => {
          refunds.push({
            id: this.refund.id,
            date: this.refund.date,
            type: this.refund.type,
            payment_method: this.refund.payment_method,
            payment_detail: this.refund.payment_detail,
            job_id: line.job_id,
            refund_number: line.fda_number,
            client_id: this.refund.client.id,
            client_name: this.refund.client.name,
            exchange_rate: this.refund.exchange_rate,
            // transaction_amount: this.lines.filter(line => line.accepted).reduce((total, line) => { total = total + parseFloat(line.total) }, 0),
            transaction_amount: line.total,
            created_user: AuthModule.user.fullname,
            modified_user: AuthModule.user.fullname,
            line: {
              id: line.id,
              type: 'Staff',
              oil_quantity: line.oil_quantity,
              water_quantity: line.water_quantity,
              amount: line.total,
              created_user: line.id !== null ? line.created_user : AuthModule.user.fullname,
              modified_user: AuthModule.user.fullname
            }
          })
        })

        if (this.isEditForm) this.update(refunds)
        else this.create(refunds)
      }

      protected create (refunds: any) {
        RefundFDAService.createRefund(refunds).then((response) => {
          ToastModule.message(response.data.message);
          (this.$parent as any).populateJobs()
          this.isEditForm = true
        }).catch(error => {
          ToastModule.message(error.response.data.message)
        })
      }

      protected update (refunds: any) {
        RefundFDAService.updateRefund(refunds).then((response) => {
          ToastModule.message(response.data.message);
          (this.$parent as any).populateJobs()
        }).catch(error => {
          ToastModule.message(error.response.data.message)
        })
      }

      protected isValidated () {
        this.$v.$touch()
        if (this.$v.$invalid) {
          NotifyModule.set('There are fields that require your attention')
          return false
        }

        /* const lineCount = this.lines.filter(line => line.name === null).length
        if (lineCount > 0) {
          NotifyModule.set('It appears that the attention rates are empty, Please check..')
          return false
        } */

        return true
      }

      protected saveAndPrint () {
        this.save()
        this.$nextTick(() => {
          this.print()
        })
      }

      protected print () {
        const refund = JSON.parse(JSON.stringify(this.refund))
        refund.lines = JSON.parse(JSON.stringify(this.lines.filter(line => line.accepted)));
        (this.$refs.TemplateFda as any).show(refund)
      }

      protected reset (obj: any) {
        for (const key in obj) {
          obj[key] = null
        }
      }

      protected cancel () {
        this.clients = []
        this.contacts = []
        this.jobs = []
        this.lines = []
        this.reset(this.refund)
        this.refund.job = {}
        this.refund.client = {}
        this.attentionType = null
        this.isEditForm = false
        this.$nextTick(() => {
          this.$v.refund.$reset()
        })
      }
}
